import { action, makeObservable, observable } from 'mobx';
import _ from 'lodash';
import moment from 'moment';
import uuid from 'react-uuid';
import genderTypes from '../../../data/genderTypes.json';
import medicaidEligibilities from '../../../data/medicaidEligibilities.json';
import recipientAidCatCodes from '../../../data/recipientAidCatCodes.json';
import housingInfoStatuses from '../../../data/housingInfoStatuses.json';
import typeOfInstitutions from '../../../data/typeOfInstitutions.json';
import housingSizeStatuses from '../../../data/housingSizeStatuses.json';
import countyRegionMapping from '../../../data/countyRegionMapping.json';
import treatmentNeeds from '../../../data/treatmentNeeds.json';
import expenditureCategories from '../../../data/expenditureCategories.json';
import expenditureDescriptions from '../../../data/expenditureDescriptions.json';
import TwoDecimalAmount from '../ExpendituresInfo/TwoDecimalAmount';


class ReimbursementStore {

    @observable openModal = false;
    @observable errorCount = 0;

    @observable reqFieldsValidationCheck = false;

    @observable responseErrors = [];

    @observable blocking;

    // Confirmation
    @observable submitSuccess = false;

    @observable confirmationId;

    // Provider Information
    @observable providerInfo = {
        agencyName: '',
        npi: '',
        contactName: '',
        contactPhone: '',
        contactEmail: ''
    }


    @observable countyList = []

    @action setCountyList(list) {
        this.countyList = list;
    }

    @action getCountyListCount() {
        return this.countyList.length;
    }

    @action setProviderInfo(name, value) {
        switch (name) {
            case 'agencyName':
                this.providerInfo.agencyName = value;
                break;
            case 'npi':
                this.providerInfo.npi = value;
                break;
            case 'contactName':
                this.providerInfo.contactName = value;
                break;
            case 'contactPhone':
                this.providerInfo.contactPhone = value;
                break;
            case 'contactEmail':
                this.providerInfo.contactEmail = value;
                break;
            default:
                break;
        }
    }

    // Enrollee Information
    @observable enrolleeInfo = {
        firstName: '',
        preferredName: '',
        middleInitial: '',
        lastName: '',
        dob: '',
        age: '',
        gender: '',
        providerOneId: '',
        stateCode: 'WA',
        medicaidEligibility: '',
        recipientAidCatCode: '',
        tribe: '',
        tribeDetails: ''
    }

    @observable attestRadio = ''

    @observable dietguidelines = []

    // Moving Attestation Provider Attest Info
    @observable providerAttestInfo = {
        provAttFirstName: '',
        provAttLastName: '',
        consentDate: '',
    }

    // Moving Attestation enrolle Attest Info
    @observable enrolleAttestInfo = {
        enrolleFirstName: '',
        enrolleLastName: '',
        consentDate: '',
        consentTime: '',
    }

    @action setAttestRadio(value) {
        this.attestRadio = value;
    }

    @action setDietGuidelines(value) {
        this.dietguidelines = value;
    }

    @action setDefaultProviderAttFields() {

        this.providerAttestInfo.provAttFirstName = this.enrolleeInfo.firstName;
        this.providerAttestInfo.provAttLastName = this.enrolleeInfo.lastName;
        this.providerAttestInfo.consentDate = "";
        this.enrolleAttestInfo.enrolleFirstName = "";
        this.enrolleAttestInfo.enrolleLastName = "";
        this.enrolleAttestInfo.consentDate = "";
        this.enrolleAttestInfo.consentTime = "";

    }

    @action setDefaultEnrolleAttFields() {
        this.providerAttestInfo.provAttFirstName = "";
        this.providerAttestInfo.provAttLastName = "";
        this.providerAttestInfo.consentDate = "";
        this.enrolleAttestInfo.enrolleFirstName = this.enrolleeInfo.firstName;
        this.enrolleAttestInfo.enrolleLastName = this.enrolleeInfo.lastName;
        this.enrolleAttestInfo.consentDate = "";
        this.enrolleAttestInfo.consentTime = "";

    }


    @action setProviderAttestInfo(name, value) {

        switch (name) {
            case 'provAttFirstName':
                this.providerAttestInfo.provAttFirstName = value;
                break;
            case 'provAttLastName':
                this.providerAttestInfo.provAttLastName = value;
                break;
            case 'consentDate':
                this.providerAttestInfo.consentDate = value;
                break;
            default:
                break;
        }

    }

    @action setEnrolleAttestInfo(name, value) {
        switch (name) {
            case 'enrolleFirstName':
                this.enrolleAttestInfo.enrolleFirstName = value;
                break;
            case 'enrolleLastName':
                this.enrolleAttestInfo.enrolleLastName = value;
                break;
            case 'consentDate':
                this.enrolleAttestInfo.consentDate = value;
                break;
            case 'consentTime':
                this.enrolleAttestInfo.consentTime = value;
                break;
            default:
                break;
        }


    }

    @observable vantageProviderOneIdSuffix = 'WA';

    @observable genderTypes = [];

    @observable medicaidEligibilities = [];

    @observable recipientAidCatCodes = [];

    @action setEnrolleeInfo(name, value) {
        switch (name) {
            case 'enrolleFirstName':
                this.enrolleeInfo.firstName = value;
                break;
            case 'enrollePreferName':
                this.enrolleeInfo.preferredName = value;
                break;
            case 'enrolleMiddleInitial':
                this.enrolleeInfo.middleInitial = value;
                break;
            case 'enrolleLastName':
                this.enrolleeInfo.lastName = value;
                break;
            case 'enrolleProvOneId':
                this.enrolleeInfo.providerOneId = value;
                break;
            case 'enrolleTribeField':
                this.enrolleeInfo.tribeDetails = value;
                break;
            default:
                break;
        }
    }

    @action setEnrolleeDOB(value) {
        this.enrolleeInfo.dob = value;
        if (value) {
            // value format - "yyyy-mm-dd"
            const dobYear = value.slice(0, 4);
            const dobMonth = value.slice(5, 7);
            const dobDay = value.slice(8);

            const today = new Date();

            let age = today.getFullYear() - dobYear;

            // JavaScript counts months from 0 (Jan) to 11 (Dec)
            const month = (today.getMonth() + 1) - dobMonth;
            if (month < 0 || (month === 0 && today.getDate() < dobDay)) {
                age -= 1;
            }
            this.enrolleeInfo.age = age
        } else {
            this.enrolleeInfo.age = '';
        }
    }



    @action setEnrolleeGender(value) {
        this.enrolleeInfo.gender = value;
    }

    @action setMedicaidEligibility(value) {
        this.enrolleeInfo.medicaidEligibility = value;
    }

    @action setrecipientAidCatCode(value) {
        this.enrolleeInfo.recipientAidCatCode = value;
    }

    @action setEnrolleTribeRadio(value) {
        this.enrolleeInfo.tribe = value;
        if (this.enrolleeInfo.tribe !== 'Yes') {
            this.enrolleeInfo.tribeDetails = '';
        }
    }

    // Housing Information
    @observable housingInfo = {
        status: '',
        housingSize: '',
        exitingInstitution: '',
        typeOfInstitution: '',
        county: '',
        region: '',
        authStartDate: '',
        authEndDate: '',
        treatmentNeed: ''
    }

    @observable housingInfoStatuses = [];

    @observable housingSizeStatuses = [];

    @observable typeOfInstitutions = [];

    @observable treatmentNeeds = [];

    @action setHousingInfoStatus(value) {
        this.housingInfo.status = value;
    }

    @action setHousingSizeStatus(value) {
        this.housingInfo.housingSize = value;
    }

    @action setHousingInfoExitingInstitutionRadio(value) {
        this.housingInfo.exitingInstitution = value;
        if (this.housingInfo.exitingInstitution !== 'Yes') {
            this.housingInfo.typeOfInstitution = '';
        }
    }

    @action setHousingInfoTypeOfInstitution(value) {
        this.housingInfo.typeOfInstitution = value;
    }

    @observable CountyRegions = countyRegionMapping[0];

    @action setHousingInfoCounty(value) {
        this.housingInfo.county = value;
        const selectedRegion = this.CountyRegions[value];
        this.housingInfo.region = selectedRegion || '';
    }

    @action setHousingInfoRegion(value) {
        this.housingInfo.region = value;
    }

    @action setAuthStartDate(value) {
        this.housingInfo.authStartDate = value;
        if (!this.housingInfo.authStartDate) {
            this.housingInfo.authEndDate = '';
        }
    }

    @action setAuthEndDate(value) {
        this.housingInfo.authEndDate = value;
    }

    @action setTreatmentNeed(value) {
        this.housingInfo.treatmentNeed = value;
    }


    @action resetReimbursementForm() {
        this.providerInfo = {
            agencyName: '',
            npi: '',
            contactName: '',
            contactPhone: '',
            contactEmail: ''
        };

        this.enrolleeInfo = {
            firstName: '',
            middleInitial: '',
            lastName: '',
            dob: '',
            age: '',
            gender: '',
            providerOneId: '',
            stateCode: 'WA',
            medicaidEligibility: '',
            recipientAidCatCode: '',
            tribe: '',
            tribeDetails: ''
        };

        this.housingInfo = {
            status: '',
            exitingInstitution: '',
            typeOfInstitution: '',
            county: '',
            region: '',
            authStartDate: '',
            authEndDate: '',
            treatmentNeed: ''
        };
    }
    // Expenditures Information

    // Category
    @observable expenditureCategory = '';

    @observable expenditureCategories = [];

    @observable expenditureDescription = '';

    @observable expenditureDescriptions = [];

    @observable filteredExpDescriptions = [];

    @observable expDescOtherDetails = '';

    @observable expenditureAmount = '';

    @observable expenditureDate = '';

    @observable showExpETP = false;

    @observable expenditureETP = '';

    @observable expenditureDetails = [];
    @observable rentalAssistance = '';

    @observable documentupload = [];
    @observable documentupload1 = [];
    @observable documentupload2 = [];

    @observable documentUploadDetails = new Array(3).fill({});

    @observable expGrandTotalAmount = '';

    @observable expInfoNotes = '';

    @action setRentalAssistance(value) {
        this.rentalAssistance = value;
    }

    @action setSingleDocumentUploadDetails(index, sinlgeDocumentUploadDetails) {
        const documentUpdates = [...this.documentUploadDetails]
        documentUpdates[index] = sinlgeDocumentUploadDetails;
        this.documentUploadDetails = documentUpdates;
    }

    @action resetDocumentObj(index) {
        const obj = this.documentUploadDetails[index]
        if (obj && Object.keys(obj).length > 0) {
            this.documentUploadDetails[index] = {}
        }
    }

    @action getDocumentsCount = () => {
        let docCount = 0
        this.documentUploadDetails.forEach((obj, index, array) => {
            if (obj && Object.keys(obj).length > 0) {
                docCount = docCount + 1;
            }
        });

        return docCount;
    }

    @action resetAllDocumentObj = () => {
        this.documentupload = [];
        this.documentupload1 = [];
        this.documentUploadDetails = new Array(2).fill({});
    }

    @action setExpenditureCategory(value) {
        this.expenditureCategory = value;
        this.filteredExpDescriptions = this.expenditureDescriptions.filter(expenditureDescription => {
            return expenditureDescription.category_name === value || expenditureDescription.category_name === 'Select';
        });
        this.expenditureDescription = '';
        this.expDescOtherDetails = '';
        this.expenditureAmount = '';
        this.expenditureDate = '';
        this.showExpETP = false;
        this.expenditureETP = '';
    }

    @action setExpenditureDescription(value) {
        this.expenditureDescription = value;
        this.expDescOtherDetails = '';
        this.expenditureAmount = '';
        this.expenditureDate = '';
        this.showExpETP = false;
        this.expenditureETP = '';
    }

    @action setExpDescOtherDetails(value) {
        this.expDescOtherDetails = value;
        this.expenditureAmount = '';
        this.expenditureDate = '';
        this.showExpETP = false;
        this.expenditureETP = '';
    }

    @action setDocumentUpload(value) {
        this.documentupload = value;
    }

    @action setDocumentUpload1(value) {
        this.documentupload1 = value;
    }

    @action setDocumentUpload2(value) {
        this.documentupload2 = value;
    }

    @action getSubTotalAmount = (expenditures, category) => {
        const exp = expenditures.filter(ex => ex.expenditureCategory === category);
        if (exp.length > 0) {
            const amount = exp
                .map(item => item.expenditureAmount)
                .reduce((prev, next) => (parseFloat(prev) + parseFloat(next)));
            return parseFloat(amount);
        }
        return 0;
    }

    @action getGrandTotalAmount() {
        if (this.expenditureDetails.length > 0) {
            const grandTotalAmount = this.expenditureDetails
                .map(x => x.expenditureAmount)
                .reduce((prev, next) => (parseFloat(prev) + parseFloat(next)));
            this.expGrandTotalAmount = grandTotalAmount;
        } else {
            this.expGrandTotalAmount = '';
        }
    }


    @action setExpDescAmount(value) {
        this.expenditureAmount = value;
        if (value) {
            const formattedExpAmt = parseFloat(value);
            const subTotalAmount = this.getSubTotalAmount(this.expenditureDetails, this.expenditureCategory);
            const formattedSubTotalAmount = subTotalAmount + formattedExpAmt;
            this.getGrandTotalAmount();
            const formattedGrandTotalAmount = this.expGrandTotalAmount ?
                parseFloat(this.expGrandTotalAmount) + formattedExpAmt
                :
                formattedExpAmt;

            if (formattedGrandTotalAmount > 15000 && (this.expenditureCategory !== 'Arrears: Utility' &&
                this.expenditureCategory !== 'Arrears: Rental' &&
                this.expenditureCategory !== 'Arrears: Storage' &&
                this.expenditureCategory !== 'Security Deposits' &&
                this.expenditureCategory !== 'First Month\'s Rent' &&
                this.expenditureCategory !== 'Last Month\'s Rent' &&
                this.expenditureCategory !== 'Pantry Stocking' &&
                this.expenditureCategory !== 'Utility Set up Fees' &&
                this.expenditureCategory !== 'Household Goods and Furniture'
            )) {
                this.showExpETP = true;
            } else if (this.expenditureCategory === 'IDs and other documentation' && formattedSubTotalAmount > 120) {
                this.showExpETP = true;
            } else if (this.expenditureCategory === 'Application fees' && formattedSubTotalAmount > 100) {
                this.showExpETP = true;
            } else if (this.expenditureCategory === 'Transitional housing fees' && formattedSubTotalAmount > 100) {
                this.showExpETP = true;
            } else if (this.expenditureCategory === 'Relocation expenses' && formattedSubTotalAmount > 1500) {
                this.showExpETP = true;
            } else if (this.expenditureCategory === 'Move-in assistance' && formattedSubTotalAmount > 1500) {
                this.showExpETP = true;
            } else if (this.expenditureCategory === 'Exception to Policy (ETP)') {
                this.showExpETP = true;
            } else {
                this.showExpETP = false;
            }
        } else {
            this.showExpETP = false;
            this.expenditureDate = '';
        }
    }

    @action setExpDate(value) {
        if (value) {
            this.expenditureDate = value;
        } else {
            this.expenditureDate = '';
        }
    }

    @action setExpETP(value) {
        this.expenditureETP = value;
    }

    @action addExpenditureDetails() {
        this.expenditureDetails.push({
            expId: uuid(),
            expenditureCategory: this.expenditureCategory,
            expenditureDescription: this.expenditureDescription,
            expenditureDescOtherDetails: this.expDescOtherDetails,
            expenditureAmount: this.expenditureAmount,
            expenditureDate: this.expenditureDate,
            expenditureETP: this.expenditureETP,
            dietguidelines: this.dietguidelines,
            rentalAssistance: this.rentalAssistance
        });
        this.getGrandTotalAmount();
    }

    @action updateExp(id) {
        const selected = this.expenditureDetails.find(x => x.expId === id);
        this.expenditureCategory = selected.expenditureCategory;
        this.filteredExpDescriptions = this.expenditureDescriptions.filter(expenditureDescription => {
            return expenditureDescription.category_name === this.expenditureCategory
                || expenditureDescription.category_name === 'Select';
        });
        this.expenditureDescription = selected.expenditureDescription;
        this.expenditureAmount = selected.expenditureAmount;
        this.expenditureDate = selected.expenditureDate;
        this.expDescOtherDetails = selected.expenditureDescOtherDetails;
        this.showExpETP = !!selected.expenditureETP;
        this.expenditureETP = selected.expenditureETP;
    }

    @action delete(id) {
        const remaining = this.expenditureDetails.filter(x => x.expId !== id);
        this.expenditureDetails = remaining;
        this.getGrandTotalAmount();
    }

    @action setExpInfoNotes(value) {
        this.expInfoNotes = value;
    }

    @action resetSelectedExpenditureDetails() {
        this.expenditureCategory = '';
        this.expenditureDescription = '';
        this.expDescOtherDetails = '';
        this.expenditureAmount = '';
        this.expenditureDate = '';
        this.expenditureETP = '';
        this.showExpETP = false;
    }

    constructor() {
        makeObservable(this);
        this.genderTypes = genderTypes;
        this.medicaidEligibilities = medicaidEligibilities;
        this.recipientAidCatCodes = recipientAidCatCodes;
        this.housingInfoStatuses = housingInfoStatuses;
        this.typeOfInstitutions = typeOfInstitutions;
        this.housingSizeStatuses = housingSizeStatuses;
        this.treatmentNeeds = treatmentNeeds;
        this.expenditureCategories = expenditureCategories;
        this.expenditureDescriptions = expenditureDescriptions;
    }

    @observable reimbursementFormData = {
        amountRequested: '',
        application: 'Provider Portal - Public',
        brand: 'WLP',
        dateReceived: "",
        notes: "",
        enrollee: {
            age: '',
            dateOfBirth: '',
            firstName: '',
            lastName: '',
            middleInitial: '',
            preferredName: '',
            gender: '',
            medicaidEligibility: '',
            memberOfTribe: '',
            providerOneId: '',
            racCode: '',
            tribe: ''
        },
        housingInformation: {
            authEndDate: '',
            authStartDate: '',
            county: '',
            exitingInstitution: '',
            housingStatus: '',
            institutionType: '',
            region: '',
            treatmentNeed: '',
            housingSize: ''
        },
        enrolleeConsent: {
            date: '',
            time: '',
            firstName: '',
            lastName: '',
            Acknowledgements: []
        },
        providerAgency: {
            id: '',
            providerAgencyName: '',
            name: '',
            npi: '',
            emailAddress: '',
            phoneNumber: '',
        },
        reimbursementInformation: [],
        serviceType: 'Reimbursement Request',
        state: 'WA',
        attachments: []
    }

    @action setExpenditureDescOtherDetailsByCategory(value, category) {
        if (category === 'Exception to Policy (ETP)') {
            return value;
        }
        return '';
    }

    @action setNotExpenditureDescOtherDetailsByCategory(value, category) {
        if (category !== 'Exception to Policy (ETP)') {
            return value;
        }
        return '';
    }

    @action submitReimbursementForm() {

        this.reimbursementFormData.dateReceived = moment().format("YYYY-MM-DD");

        this.reimbursementFormData.amountRequested = TwoDecimalAmount(parseFloat(this.expGrandTotalAmount));

        this.reimbursementFormData.enrollee.age = this.enrolleeInfo.age;

        this.reimbursementFormData.enrollee.dateOfBirth = this.enrolleeInfo.dob;

        this.reimbursementFormData.enrollee.firstName = this.enrolleeInfo.firstName;

        this.reimbursementFormData.enrollee.lastName = this.enrolleeInfo.lastName;

        this.reimbursementFormData.enrollee.middleInitial = this.enrolleeInfo.middleInitial;

        this.reimbursementFormData.enrollee.gender = this.enrolleeInfo.gender;

        this.reimbursementFormData.enrollee.medicaidEligibility = this.enrolleeInfo.medicaidEligibility;

        this.reimbursementFormData.enrollee.memberOfTribe = this.enrolleeInfo.tribe === 'Yes';

        this.reimbursementFormData.enrollee.providerOneId =
            `${this.enrolleeInfo.providerOneId}${this.vantageProviderOneIdSuffix}`;

        this.reimbursementFormData.enrollee.racCode = this.enrolleeInfo.recipientAidCatCode;

        this.reimbursementFormData.enrollee.tribe = this.enrolleeInfo.tribeDetails;

        this.reimbursementFormData.enrollee.preferredName = this.enrolleeInfo.preferredName;

        this.reimbursementFormData.housingInformation.authEndDate =
            this.housingInfo.authStartDate && this.housingInfo.authEndDate ?
                moment(this.housingInfo.authEndDate).format('YYYY-MM-DD') : '';

        this.reimbursementFormData.housingInformation.authStartDate = this.housingInfo.authStartDate ?
            moment(this.housingInfo.authStartDate).format('YYYY-MM-DD') : '';

        this.reimbursementFormData.housingInformation.county = this.housingInfo.county;

        this.reimbursementFormData.housingInformation.exitingInstitution = this.housingInfo.exitingInstitution === 'Yes';

        this.reimbursementFormData.housingInformation.housingStatus = this.housingInfo.status;

        this.reimbursementFormData.housingInformation.institutionType = this.housingInfo.exitingInstitution ?
            this.housingInfo.typeOfInstitution : '';

        this.reimbursementFormData.housingInformation.region = this.housingInfo.county ?
            this.housingInfo.region : '';

        this.reimbursementFormData.housingInformation.treatmentNeed = this.housingInfo.treatmentNeed;

        this.reimbursementFormData.housingInformation.housingSize = this.housingInfo.housingSize;

        this.reimbursementFormData.notes = this.expInfoNotes;

        this.reimbursementFormData.providerAgency.emailAddress = this.providerInfo.contactEmail;

        this.reimbursementFormData.providerAgency.npi = this.providerInfo.npi;

        this.reimbursementFormData.providerAgency.phoneNumber = this.providerInfo.contactPhone;

        this.reimbursementFormData.providerAgency.providerAgencyName = this.getProviderAgencyName(this.providerInfo);

        this.reimbursementFormData.providerAgency.name = this.providerInfo.contactName;

        this.reimbursementFormData.providerAgency.id = this.getProviderAgencyId(this.providerInfo);

        const reimbursementInfoArr = [];

        [...this.expenditureDetails].forEach(exp => {
            if (reimbursementInfoArr.filter(x => x.categoryInfo === exp.expenditureCategory).length === 0)
                reimbursementInfoArr.push(
                    {
                        categoryInfo: exp.expenditureCategory,
                        expenditureDetails: [
                            {
                                dateOfExpenditure: exp.expenditureDate,
                                descriptionOfExpenditure: exp.expenditureDescription,
                                etpRequestDescription: exp.expenditureETP,
                                etpOtherDescription: this.setExpenditureDescOtherDetailsByCategory(exp.expenditureDescOtherDetails, exp.expenditureCategory),
                                exceptionToPolicy: !!exp.expenditureETP,
                                expenditure: parseFloat(exp.expenditureAmount),
                                otherDescription: this.setNotExpenditureDescOtherDetailsByCategory(exp.expenditureDescOtherDetails, exp.expenditureCategory)

                            }
                        ],
                        subtotals: this.getSubTotalAmount(this.expenditureDetails, exp.expenditureCategory)
                    }
                );
            else {
                reimbursementInfoArr.forEach(element => {
                    if (element.categoryInfo === exp.expenditureCategory) {
                        element.expenditureDetails.push({
                            dateOfExpenditure: exp.expenditureDate,
                            descriptionOfExpenditure: exp.expenditureDescription,
                            etpRequestDescription: exp.expenditureETP,
                            etpOtherDescription: this.setExpenditureDescOtherDetailsByCategory(exp.expenditureDescOtherDetails, exp.expenditureCategory),
                            exceptionToPolicy: !!exp.expenditureETP,
                            expenditure: parseFloat(exp.expenditureAmount),
                            otherDescription: this.setNotExpenditureDescOtherDetailsByCategory(exp.expenditureDescOtherDetails, exp.expenditureCategory)
                        })
                    }
                });
            };
        });

        this.reimbursementFormData.reimbursementInformation = reimbursementInfoArr;

        if (this.attestRadio === 'Provider Attest') {
            this.reimbursementFormData.enrolleeConsent.firstName = this.providerAttestInfo.provAttFirstName;
            this.reimbursementFormData.enrolleeConsent.lastName = this.providerAttestInfo.provAttLastName;
            this.reimbursementFormData.enrolleeConsent.date = this.providerAttestInfo.consentDate;
            this.reimbursementFormData.enrolleeConsent.Acknowledgements.push({
                "ecCode": "ACK05",
                "ecValue": "I, the provider, attest that the following enrollee is making a housing transition."
            });
        } else {
            this.reimbursementFormData.enrolleeConsent.firstName = this.enrolleAttestInfo.enrolleFirstName;
            this.reimbursementFormData.enrolleeConsent.lastName = this.enrolleAttestInfo.enrolleLastName;
            this.reimbursementFormData.enrolleeConsent.date = this.enrolleAttestInfo.consentDate;
            this.reimbursementFormData.enrolleeConsent.time = this.enrolleAttestInfo.consentTime;
            this.reimbursementFormData.enrolleeConsent.Acknowledgements.push({
                "ecCode": "ACK06",
                "ecValue": "I, the enrollee, attest that I am making a housing transition."
            });
        }
        if (this.dietguidelines.length > 0) {
            this.reimbursementFormData.enrolleeConsent.Acknowledgements.push({
                "ecCode": "ACK07",
                "ecValue": "I, the provider, attest that the enrollee has received the resources on the Dietary guidelines of America."
            });
        }
        const attachments = this.documentUploadDetails.filter(uploadObj =>
            uploadObj && uploadObj.percetComp && uploadObj.percetComp === 100
        ).map(uploadObj => {
            return {
                "documentName": `ETP ${uploadObj.documentName}`,
                "fileName": uploadObj.updatedFileName
            };
        });

        this.reimbursementFormData.attachments = attachments;


        return this.reimbursementFormData;
    }


    @action clearReimbursementForm() {
        this.openModal = false;
        this.errorCount = 0;
        this.submitSuccess = false;

        this.confirmationId = undefined;

        // Provider Information
        this.providerInfo = {
            agencyName: '',
            npi: '',
            contactName: '',
            contactPhone: '',
            contactEmail: ''
        };

        // Enrollee Information
        this.enrolleeInfo = {
            firstName: '',
            middleInitial: '',
            lastName: '',
            dob: '',
            age: '',
            gender: '',
            providerOneId: '',
            stateCode: 'WA',
            medicaidEligibility: '',
            recipientAidCatCode: '',
            tribe: '',
            tribeDetails: ''
        };

        // Housing Information
        this.housingInfo = {
            status: '',
            exitingInstitution: '',
            typeOfInstitution: '',
            county: '',
            region: '',
            authStartDate: '',
            authEndDate: '',
            treatmentNeed: ''
        };

        this.expenditureCategory = '';

        this.expenditureDescription = '';

        this.expDescOtherDetails = '';

        this.expenditureAmount = '';

        this.expenditureDate = '';

        this.showExpETP = false;

        this.expenditureETP = '';

        this.expGrandTotalAmount = '';

        this.expenditureDetails = [];

        this.expInfoNotes = '';

        this.documentUploadDetails = new Array(2).fill({});

        this.reimbursementFormPages = [
            { title: 'Provider & Enrollee', state: 'stepwizard-step active', href: '#reimbursementform', key: 0 },
            { title: 'Expenditure Information', state: 'stepwizard-step disabled', href: '#expendituresinfo', key: 1 },
            { title: 'Moving Attestation', state: 'stepwizard-step disabled', href: '#movingattestation', key: 2 },
            { title: 'Documentation', state: 'stepwizard-step disabled', href: '#documentation', key: 3 },
            { title: 'Review & Submit', state: 'stepwizard-step disabled', href: '#reviewsubmit', key: 4 },
        ];
    }

    @action setReqFieldsValidationCheck() {
        if (this.providerInfo.agencyName &&
            this.providerInfo.npi &&
            this.providerInfo.contactName &&
            this.providerInfo.contactPhone &&
            this.providerInfo.contactEmail &&
            this.enrolleeInfo.firstName &&
            this.enrolleeInfo.lastName &&
            this.enrolleeInfo.dob &&
            this.enrolleeInfo.gender &&
            this.enrolleeInfo.providerOneId &&
            this.enrolleeInfo.medicaidEligibility &&
            this.enrolleeInfo.recipientAidCatCode &&
            this.housingInfo.status &&
            this.housingInfo.exitingInstitution &&
            this.housingInfo.county &&
            this.housingInfo.authStartDate &&
            this.housingInfo.authEndDate &&
            this.housingInfo.treatmentNeed &&
            this.expGrandTotalAmount &&
            this.expenditureDetails.length > 0) {
            this.reqFieldsValidationCheck = false;
        }
        else {
            this.reqFieldsValidationCheck = true;
        }
    }

    @action setOpenModal() {
        this.openModal = !this.openModal;
    }

    @action incrementErrorCount() {
        if (this.errorCount + 1 === 3) {
            this.errorCount = 0;
        } else {
            this.errorCount = this.errorCount + 1;
        }
    }

    @action resetErrorCount() {
        this.errorCount = 0;
    }

    @action turnOnBlocking() {
        this.blocking = true;
    }

    @action turnOffBlocking() {
        this.blocking = false;
    }

    @action getReimbursementPageStatus(pageKey) {
        const page = _.find(this.reimbursementFormPages, page => page.href === pageKey);
        return page.state;
    }

    @action setReimbursementPageStatus(pageKey, pageState) {
        const pages = [...this.reimbursementFormPages]
        const page = _.find(pages, page => page.href === pageKey);
        const pageStateString = `stepwizard-step ${pageState}`;
        page.state = pageStateString;
        this.reimbursementFormPages = [...pages];
    }

    @observable reimbursementFormPages = [
        { title: 'Provider & Enrollee', state: 'stepwizard-step active', href: '#reimbursementform', key: 0 },
        { title: 'Expenditure Information', state: 'stepwizard-step disabled', href: '#expendituresinfo', key: 1 },
        { title: 'Moving Attestation', state: 'stepwizard-step disabled', href: '#movingattestation', key: 2 },
        { title: 'Supporting Documentation', state: 'stepwizard-step disabled', href: '#documentation', key: 3 },
        { title: 'Review & Submit', state: 'stepwizard-step disabled', href: '#reviewsubmit', key: 4 },
    ];

    getProviderAgencyName(providerInfo) {
        if (!providerInfo.agencyName) {
            return "";
        }
        return typeof providerInfo.agencyName === "string" ? providerInfo.agencyName : providerInfo.agencyName.label;
    }

    getProviderAgencyId(providerInfo) {
        if (!providerInfo.agencyName) {
            return "";
        }
        return typeof providerInfo.agencyName === "string" ? "" : providerInfo.agencyName.value;
    }

    getProvAgencyAbbr(providerInfo) {
        if (!providerInfo.agencyName)
            return undefined;

        if (typeof providerInfo.agencyName === 'string') {
            return undefined;
        }
        const agencyAbbr = this.providerInfo.agencyName ? this.providerInfo.agencyName.abbr : undefined;
        return agencyAbbr.replace(/ /g, '');

    }

}

export default new ReimbursementStore();